import {createAction} from '@reduxjs/toolkit';
import {createGeometryObj} from '@src/utils/geom.js';

const actionPrefix = 'SEARCH';

export const setDateRanges = createAction(`${actionPrefix}/SET_DATE_RANGES`);

export const resetDateRanges = createAction(
  `${actionPrefix}/RESET_DATE_RANGES`,
);

export const saveGeometry = createAction(`${actionPrefix}/SAVE_GEOMETRY`);

export const setIsGeometryTooComplex = createAction(
  `${actionPrefix}/IS_GEOMETRY_TOO_COMPLEX`,
);

export const defineGeometry =
  ({
    geometry,
    zoomTo = true,
    isGeometryTooComplex = false,
    fromHash = false,
    featureReference,
  }) =>
  dispatch => {
    const {newGeometry, geometryTooLarge} = createGeometryObj(geometry);

    dispatch(
      saveGeometry({
        geometry: newGeometry,
        geometryTooLarge,
        geometryZoomTo: zoomTo,
        isGeometryTooComplex,
        fromHash,
        featureReference,
      }),
    );
  };

export const continueSearch = createAction(`${actionPrefix}/CONTINUE_SEARCH`);

export const clearSearch = createAction(`${actionPrefix}/CLEAR_SEARCH`);

export const toggleNoEndDate = createAction(
  `${actionPrefix}/TOGGLE_NO_END_DATE`,
);

export const loadSearch = createAction(`${actionPrefix}/LOAD_SEARCH`);

export const searchSingleItem = createAction(
  `${actionPrefix}/SEARCH_SINGLE_ITEM`,
);

export const executeSearch = createAction(`${actionPrefix}/EXECUTE_SEARCH`);

export const resetSearchPageNumber = createAction(
  `${actionPrefix}/RESET_SEARCH_PAGE_NUMBER`,
);
